import {Component} from '@angular/core';
import {NgxSpinnerService} from 'ngx-spinner';
import {ContractsWarrantiesService} from '../../../Services/contracts-warranties.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CustomToastrService} from '../../../Shared/Services/custom-toastr.service';
import {AuthService} from '../../../Shared/Services/auth.service';
import {UserType} from '../../../Shared/Enums/UserType';
import {ContractInfoVM} from '../../../Model/contracts-warranties/ContractInfoVM';
import {DownloadService} from '../../../Services/download.service';
import {
  SendWhatsAppMessageComponent
} from '../../../Shared/Components/send-whats-app-message/send-whats-app-message.component';
import {SharedService} from '../../../Shared/Services/shared.service';
import {DialogService} from '../../../Shared/Services/dialog.service';
import {LoginVm} from '../../../Model/LoginVM';

@Component({
  selector: 'app-contract-details',
  templateUrl: './contract-details.component.html',
  styleUrl: './contract-details.component.scss'
})
export class ContractDetailsComponent {
  ContractDetailsInfo!: ContractInfoVM;
  ContractId?: number;
  currentUser: LoginVm = {};

  constructor(private api: ContractsWarrantiesService, private route: ActivatedRoute, private auth: AuthService, private router: Router,
              private spinner: NgxSpinnerService, private toastrService: CustomToastrService, private shared: SharedService,
              private download: DownloadService) {
  }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery, UserType.Client])) {
      this.spinner.show();
      this.GetCurrentUser();
      this.route.params.subscribe(params => {
        const id = params['id'];
        this.ContractId = id;
        this.GetContractDetails(id);
      });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetCurrentUser() {
    let jsonObj = this.auth.getStorage("currentUser");
    this.currentUser = <LoginVm>JSON.parse(jsonObj);
  }

  GetContractDetails(ContractId?: number) {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery, UserType.Client])) {
      this.api.GetContractDetails(ContractId).subscribe(
        {
          next: (data: any) => {
            this.spinner.hide();
            this.ContractDetailsInfo = data;
          },
          error: (error: any) => {
            this.spinner.hide();
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  Cancel() {
    if (this.currentUser.userType == UserType.Client) {
      this.router.navigateByUrl('dashboard/contracts-list');
    } else {
      this.router.navigateByUrl('dashboard/contracts-warranties');
    }
  }

  ClacArea(width?: any, height?: any): number {
    return this.shared.ClacArea(width, height);
  }

  SendWhatsAppMessage() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      // let url = this.download.ContractPDFUrl(this.ContractId);
      // this.shared.SendWhatsAppMessage(url, true);
      this.spinner.show();
      this.download.ContractToPdf(this.ContractId)
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              const blobUrl = URL.createObjectURL(data);
              this.shared.SendWhatsAppMessage(blobUrl,true);
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  exportPDF() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.spinner.show();
      this.download.ContractToPdf(this.ContractId)
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              this.shared.downloadBlobFile(data, 'Contract');
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }
}
